import * as React from 'react';
import type { SVGProps } from 'react';
const SvgStateinfo = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={14} height={15} fill="none" {...props}>
    <path fill="#616061" d="M0 0v15h2V9h4l2 2h6V2H8L6 0z" />
  </svg>
);
export default SvgStateinfo;
